import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { QrtApiService } from '../qrt-api/qrt-api.service';
import { StateAndAssociation, StateAndAssociationQrtRow } from './state-and-association.type';

const STATE_AND_ASSOCIATION_REPORT_GUID = '881E12B8-B7A0-48D2-8DC5-13E13129B1C5';

function asString(value: unknown): string {
  return typeof value === 'string' ? value : '';
}

function mapStateAndAssociationRow(row: unknown): StateAndAssociation {
  const qrtRow = row as StateAndAssociationQrtRow;

  return {
    stateAbbr: asString(qrtRow.State_Abbr),
    state: asString(qrtRow.State),
    stateAssociationId: asString(qrtRow.State_Association_ID),
    associationName: asString(qrtRow.Association_Name),
    primaryStateAssociationId: asString(qrtRow.primary_state_assoc_id),
  };
}

@Injectable({ providedIn: 'root' })
export class StateAndAssociationService {
  private readonly qrtApiService = inject(QrtApiService);

  getStateAndAssociations(): Observable<StateAndAssociation[]> {
    return this.qrtApiService
      .generateReport(STATE_AND_ASSOCIATION_REPORT_GUID, [])
      .pipe(map((rows) => rows.map(mapStateAndAssociationRow)));
  }
}
